import { roles } from "../../../../helpers/utils/Constants/roles";

  export const getSlugByUsingUserRole = (role: string) => {
    if (role === "user") {
      return "tour-video";
    } if (role === roles.SELF_PACED_SCRUM_MASTER_STUDENT) {
      return "self-paced-scrum-master-onboarding-video";
    } if (role === roles.SELF_PACED_PRODUCT_MANAGER_STUDENT) {
      return "self-paced-product-manager-onboarding-video";
    } 
    return "tour-video"
  };

export const getRoleValue = (role:string)=>{
     if (role === "user") {
      return "user_dashboard";
    } if (role === roles.SELF_PACED_SCRUM_MASTER_STUDENT) {
      return "self_paced_scrum_master";
    } if (role === roles.SELF_PACED_PRODUCT_MANAGER_STUDENT) {
      return "self_paced_product_manager";
    } 
    return "user_dashboard"
}